import * as React from 'react';

import { DropzoneRef } from 'react-dropzone';

import { Button } from '@components/common';
import { useAuthProvider } from '@hooks/useAuthProvider';

import { useBulkUploadActions, useBulkUploadState } from '../context';

export const UploadActionButtons = ({ onBrowseFiles }: { onBrowseFiles: DropzoneRef['open'] }) => {
  const { studyId } = useBulkUploadState();
  const { openZoomImportModal } = useBulkUploadActions();

  const { getButtonProps, isConnected, isInvalid, isLoading } = useAuthProvider('zoom');

  return (
    <>
      {((isConnected && !isInvalid) || isLoading) && (
        <Button
          disabled={isLoading}
          className='whitespace-nowrap'
          icon='uploadZoom'
          medium
          onClick={() => openZoomImportModal(studyId)}
        >
          Import from Zoom
        </Button>
      )}
      {(!isConnected || isInvalid) && !isLoading && (
        <Button
          medium
          icon='uploadZoom'
          className='whitespace-nowrap'
          {...getButtonProps({ callback: () => openZoomImportModal(studyId) })}
        >
          {isInvalid ? 'Re-authorize Zoom' : 'Connect Zoom'}
        </Button>
      )}
      <Button medium className='whitespace-nowrap' icon='uploadVideo' onClick={onBrowseFiles}>
        Browse files
      </Button>
    </>
  );
};
